'use client';

import { RadialBarChart, RadialBar, ResponsiveContainer } from 'recharts';
import Icon from '@/components/ui/AppIcon';

export default function ThreatScoreHero() {
  const score = 74;
  const level = score >= 80 ? 'Critical' : score >= 60 ? 'High' : score >= 40 ? 'Medium' : 'Low';
  const levelColor = score >= 80 ? '#ef4444' : score >= 60 ? '#f97316' : score >= 40 ? '#f59e0b' : '#3b82f6';

  const data = [
    { name: 'score', value: score, fill: levelColor },
    { name: 'bg', value: 100, fill: 'rgba(255,255,255,0.04)' },
  ];

  return (
    <div className="lg:col-span-2 bg-zinc-900 border border-zinc-800 rounded-xl p-5 flex flex-col gap-2 relative overflow-hidden">
      {/* Glow */}
      <div
        className="absolute inset-0 rounded-xl opacity-20 pointer-events-none"
        style={{ background: `radial-gradient(circle at 30% 50%, ${levelColor}22, transparent 70%)` }}
      />
      <div className="flex items-start justify-between relative z-10">
        <div>
          <p className="text-[11px] font-semibold uppercase tracking-widest text-zinc-500 mb-1">Ağ Tehdit Skoru</p>
          <div className="flex items-baseline gap-2">
            <span className="text-5xl font-bold tabular-nums" style={{ color: levelColor }}>{score}</span>
            <span className="text-lg font-medium text-zinc-500">/100</span>
          </div>
          <div className="flex items-center gap-2 mt-2">
            <span
              className="inline-flex items-center gap-1 text-xs font-semibold px-2 py-0.5 rounded-full border"
              style={{ color: levelColor, backgroundColor: `${levelColor}18`, borderColor: `${levelColor}30` }}
            >
              <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: levelColor }}></span>
              {level} Risk
            </span>
            <span className="text-xs text-zinc-600 flex items-center gap-1">
              <Icon name="ArrowTrendingUpIcon" size={12} className="text-orange-500" />
              <span className="text-orange-400">+12 pts</span>
              <span className="text-zinc-600">vs 1s önce</span>
            </span>
          </div>
        </div>

        <div className="w-28 h-28 flex-shrink-0">
          <ResponsiveContainer width="100%" height="100%">
            <RadialBarChart
              cx="50%"
              cy="50%"
              innerRadius="65%"
              outerRadius="100%"
              startAngle={90}
              endAngle={-270}
              data={data}
              barSize={8}
            >
              <RadialBar dataKey="value" cornerRadius={4} background={{ fill: 'rgba(255,255,255,0.04)' }} />
            </RadialBarChart>
          </ResponsiveContainer>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-3 mt-1 pt-3 border-t border-zinc-800 relative z-10">
        {[
          { label: 'Aktif Tehditler', value: '23', color: '#ef4444' },
          { label: 'Bugün Engellenen', value: '1,847', color: '#10b981' },
          { label: 'İnceleme Bekleyen', value: '41', color: '#f59e0b' },
        ]?.map((item) => (
          <div key={item?.label}>
            <p className="text-[10px] text-zinc-600 uppercase tracking-wide">{item?.label}</p>
            <p className="text-lg font-bold tabular-nums mt-0.5" style={{ color: item?.color }}>{item?.value}</p>
          </div>
        ))}
      </div>
    </div>
  );
}